
export class QuotationPaymentDO {

	public id: Number = null;

	public paymentMethodCd: String = null;

	public paymentFrequencyCd: String = null;

	public accountNumber: String = null;

	public accountHolderName: String = null;

	public getId() {
		return this.id;
	}
	public setId(id: Number) {
		this.id = id;
	}
	public getPaymentMethodCd() {
		return this.paymentMethodCd;
	}
	public setPaymentMethodCd(paymentMethodCd: String) {
		this.paymentMethodCd = paymentMethodCd;
	}
	public getPaymentFrequencyCd() {
		return this.paymentFrequencyCd;
	}
	public setPaymentFrequencyCd(paymentFrequencyCd: String) {
		this.paymentFrequencyCd = paymentFrequencyCd;
	}
	public getAccountNumber() {
		return this.accountNumber;
	}
	public setAccountNumber(accountNumber: String) {
		this.accountNumber = accountNumber;
	}
	public getAccountHolderName() {
		return this.accountHolderName;
	}
	public setAccountHolderName(accountHolderName: String) {
		this.accountHolderName = accountHolderName;
	}
}